module.exports = __webpack_public_path__ + "../resources/img/ic_edit_default.8d3c0439.svg";